<template>
  <div class="page_custom--role_and_permission" v-loading="loading">
    <div>
      <BaseSelect
          :data="{}"
          v-model="select_roles"
          :field="{option:roles_list, key:'id',limit:3}"
          :action="'Edit'"
          :options="{}"
          :key="BaseSelectKey"
          @input="selected"
        />
    </div>
    <br>
    <div class="rnp-table">
      <div class="header">
        <table class="header-table">
          <thead>
            <tr>
              <td></td>
              <td v-for="role in display_roles" :key="role.id">{{ role.name_chi }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td v-for="role in display_roles" :key="role.id" class="no-spacing">
                <div style="padding: 5px 0;">
                  <el-button size="mini" @click="toggleAll(role.id)">{{ $t("button.select_all") }}</el-button>
                </div>
                <table class="privilege-type">
                  <tr>
                    <td v-for="type in privilege_types" :key="type">{{ $t(`field.role_n_permission.${type}`) }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="content">
        <div class="group">
          <table class="content-table">
            <tr v-for="privi in Object.keys(grouped_privileges.by_type)" :key="privi">
              <td class="text-left">{{ $t(`menu.item.${privi}`) }}</td>
              <td v-for="(role) in display_roles" :key="role.id" class="no-spacing">
                <table class="privi-table">
                  <tr>
                    <td
                      v-for="type in privilege_types"
                      :key="type"
                      @click="toggleOne(role.id, grouped_privileges.by_type[privi][type].id)"
                    >
                      <div class="colored-wrap" v-if="grouped_privileges.by_type[privi][type]" :class="{ 'changed':  rnp_map[role.id][grouped_privileges.by_type[privi][type].id] !== original_rnp_map[role.id][grouped_privileges.by_type[privi][type].id] }"> 
                        <input type="checkbox" v-model="rnp_map[role.id][grouped_privileges.by_type[privi][type].id]" true-value="1" false-value="0"/>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="footer">
      <el-button type="info" @click="reset" size="mini">{{ $t("button.reset") }}</el-button>
      <el-button type="primary" size="small" @click="confirm">{{ $t("button.confirm") }}</el-button>
    </div>

    <!-- <div class="rnp-table">
      <div class="header">
        <div class="head" v-for="role in roles" :key="role.id">{{ role.name }}</div>
      </div>
      <div class="body">
        <div class="groups" v-for="type in Object.keys(this.grouped_privileges)" :key="type">
          <div class="header">{{ type }}</div>
          <div class="group" v-for="privi in grouped_privileges[type]" :key="privi.id">
            <div class="privilege">
              <div class="name">{{ privi.name }}</div>
              <div class="role" v-for="(role,index) in roles" :key="role.id" @click="toggleOne(role.id, privi.id)">
                <input type="checkbox" v-model="rnp_map[role.id][privi.id]" true-value="1" false-value="0"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseSelect from "@/views/crud/modules/BaseSelect";

export default {
  components: {
    BaseSelect,
  },
  async beforeMount() {
    this.loading = true;
    await this.init();
    this.loading = false;
  },
  methods: {
    selected(data){
      this.display_roles = this.roles.filter(r=>{
        var obj = [];
        if(data != "" && data.indexOf(",") != -1){
          obj = data.split(",");
        }
        else {
          obj.push(data);
        }
        if(obj.length > 0 && obj.indexOf(r.id.toString()) != -1){
          return r;
        }
      })
    },
    async init() {
      // this.roles = (await this.$axios.get(`roles`))
      await this.$axios.get(`roles`).then(res=>{
        this.roles = res.data.response.dataset.filter(role=>this.user_info.max_role_level>=role.level).sort((a,b)=>a.level-b.level);
      }).catch(err=>false);
      this.privileges = (await this.$axios.get(`privileges`, {
        params: {
          enable_flag: 1
        }
      })).data.response.dataset;
      this.roles_list=[];
      this.roles.map(role=>{
        var obj = {id:role.id, name:role.name_chi};
        this.roles_list.push(obj);
        this.BaseSelectKey=1;
        this.original_rnp_map[role.id] = [];
        this.rnp_map[role.id] = [];
        // init toggle map
        this.toggle[role.id] = "0";
        this.privileges.map(privi=>{
          let found = role.privileges.find(rp=>rp.id==privi.id);
          this.original_rnp_map[role.id][privi.id] = found ? "1" : "0";
          this.rnp_map[role.id][privi.id] = found ? "1" : "0";
        });
      });

      this.grouped_privileges.read = [];
      this.grouped_privileges.edit = [];
      this.grouped_privileges.create = [];
      this.grouped_privileges.other = [];
      this.privileges.map(p=>{
        let regexp = /^([^_]+)_(.+)/.exec(p.name);
        if(regexp != null && regexp.length >= 3) {
          let type = regexp[1].toLowerCase();
          let privi = regexp[2].toLowerCase();

          this.grouped_privileges.by_type[privi] = this.grouped_privileges.by_type[privi] ? this.grouped_privileges.by_type[privi] : {};
          this.grouped_privileges.by_type[privi][type] = p;
        }
        if(/^READ_(.+)/.test(p.name)) {
          this.grouped_privileges.read.push(p);
        }else if(/^EDIT_(.+)/.test(p.name)) {
          this.grouped_privileges.edit.push(p);
        }else if(/^CREATE_(.+)/.test(p.name)) {
          this.grouped_privileges.create.push(p);
        }else {
          this.grouped_privileges.other.push(p);
        }
      });
      return true;
    },
    toggleOne(role_id, privi_id) {
      console.log("role_id: ", role_id);
      console.log("privi_id: ", privi_id);
      let value = this.toggle[role_id] == "1" ? "0" : "1";
      this.toggle[role_id] = value;
      this.$set(this.rnp_map[role_id], privi_id, value);
      this.$forceUpdate();
    },
    toggleAll(role_id) {
      let value = this.toggle[role_id] == "1" ? "0" : "1";
      this.toggle[role_id] = value;
      this.privileges.map(privi=>{
        this.$set(this.rnp_map[role_id], privi.id, value);
      });
      this.$forceUpdate();
    },
    reset() {
      Object.keys(this.original_rnp_map).map(r=>{
        this.toggle[r] = "0";
        this.rnp_map[r].map((p,i)=>{
          this.rnp_map[r][i] = this.original_rnp_map[r][i];
        });
      });
      this.$forceUpdate();
    },
    getPrivilegeName(str) {
      let values = /^([^_]+)_(.+)/.exec(str);
      if(values != null && values.length == 3) {
        let type = values[1].toLowerCase();
        let privi = values[2].toLowerCase();
        // return `
        // <div class="privi-type">${ this.$te(`role_n_permission.${type}`) ? this.$t(`role_n_permission.${type}`) : type }</div>
        // ${ this.$te(`menu.item.${privi}`) ? this.$t(`menu.item.${privi}`) : privi }
        // `;
        return `
        ${ this.$te(`menu.item.${privi}`) ? this.$t(`menu.item.${privi}`) : privi }
        `;
      }else {
        return str;
      }
    },
    checkChanges() {
      let changed = [];
      Object.keys(this.original_rnp_map).map(r=>{
        this.toggle[r] = "0";
        this.rnp_map[r].map((p,i)=>{
          if(this.rnp_map[r][i] !== this.original_rnp_map[r][i]) {
            // changed++;
            changed.push(r);
          }
        });
      });
      return changed;
    },

    async confirm() {
      // let request_object = [];
      let changed = this.checkChanges();
      if(changed.length == 0) {
        this.$message({
          message: this.$t("error.no_changes"),
          type: 'error'
        });
        return;
      }

      if(!await this.$confirm(this.$tc("message.confirm_n_items_is_changes",null,{x:changed.length}), this.$t("label.confirm_to_save"), {
        confirmButtonText: this.$t("button.confirm"),
        cancelButtonText: this.$t("button.cancel"),
        type: 'warning'
      })) return;

      this.loading = true;
      let request_object = Object.keys(this.rnp_map).map(r=>{
        return {
          role_id: parseInt(r),
          changed: changed.includes(r) ? 1 : 0,
          privileges: this.rnp_map[r].map((p,i)=>{
            if(p && p == "1") {
              return i;
            }
          }).filter(p=>p).map(p=>{
            let privilege = this.privileges.find(privi=>privi.id==p);
            return privilege ? privilege : {};
          })
        };
      });
      console.log(request_object);
      request_object = request_object.filter(r=>{
        var obj = [];
        if(this.select_roles != "" && this.select_roles.indexOf(",") != -1){
          obj = this.select_roles.split(",");
        }
        else {
          obj.push(this.select_roles);
        }
        if(obj.length > 0 && obj.indexOf(r.role_id.toString()) != -1){
          return r;
        }
      });
      console.log(request_object);
      await this.$axios.post("/role_n_permission", request_object).catch(err=>{
        this.$message({
          message: this.$t("error.generic"),
          type: 'error'
        });
        return false;
      });
      await this.init();
      await this.$store.dispatch("user/fetchPermissions");
      this.loading = false;
    }
  },
  computed: {
    ...mapState({
      user_info: state => state.user.user_info
    }),
    // displayRoles(){
    //   var m = this.roles.filter(r=>{
    //     var obj = [];
    //     if(this.select_roles != "" && this.select_roles.indexOf(",") != -1){
    //       obj = this.select_roles.split(",");
    //     }
    //     else {
    //       obj.push(this.select_roles);
    //     }
    //     if(obj.length > 0 && obj.indexOf(r.id) != -1){
    //       return r;
    //     }
    //   })
    //   return m;
    // }
  },
  data() {
    return {
      BaseSelectKey:0,
      loading: false,
      roles: [],
      select_roles: "",
      roles_list: [],
      privileges: [],
      display_roles:[],
      privilege_types: ["read","create","edit"],
      grouped_privileges: {
        read: [],
        create: [],
        edit: [],
        other: [],

        by_type: {}
      },
      toggle: [],

      original_rnp_map: {},
      rnp_map: {}
    }
  }
}
</script>

<style lang="scss">
.page_custom--role_and_permission{
  display: flex;
  flex-direction: column;
  .header{
    overflow-y: scroll;
  }
  .content{
    // header: 135px
    // footer: 40px
    height: calc(92vh - 135px - 40px - 10px - 50px);
    overflow-y: scroll;
    .changed{
      background: #feffce;
    }
  }
  .footer{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    button{
      height: 32px;
    }
  }
  .text-left{
    text-align: left;
  }
  .no-spacing{
    padding: 0;
  }
  // for border
  table{
    &.header-table{
      border-top: 1px solid #ebeef5!important;
      border-left: 1px solid #ebeef5!important;
      border-right: 1px solid #ebeef5!important;
      thead{
        td{
          border-bottom: 1px solid #ebeef5!important;
        }
      }
      td:not(:last-child){
        border-right: 1px solid #ebeef5!important;
      }
    }
    &.privilege-type{
      border-top: 1px solid #ebeef5!important;
    }
    &.content-table{
      border: 1px solid #ebeef5!important;
      & > tr:nth-child(odd){
        background:#eee;
      }
      & > tr td:first-child{
        border-left: 1px solid #ebeef5!important;
      }
      & > tr > td{
        border-bottom: 1px solid #ebeef5!important;
      }
      .privi-table{
        td{
          border-left: 1px solid #ebeef5!important;
        }
      }
    }
  }
  // actual style
  .rnp-table{
    overflow-x: auto;
  }
  table{
    width: 100%;
    border: 0;
    border-spacing: 0;
    border-collapse: separate;
    table-layout: fixed;
    tr{
    }
    td{
      word-break: break-all;
      padding: 5px 10px;
      text-align: center;
      min-height: 30px;
    }
  }
  table{
    &.header-table{
      td{
        min-width: 200px;
        width: 100%;
      }
      .privilege-type{
        font-size: small;
      }
    }
    &.content-table{
      tr{
        // padding: 2px 10px;
        td{
          font-size: small;
        }
      }
    }
  }
  .privi-table{
    td{
      text-align: center;
      padding: 0px;
      min-height: 30px;
      .colored-wrap{
        padding: 5px 10px;
      }
    }
  }
  .group{
    margin-bottom: 10px;
    .type{
      background: #ebeef5;
      padding: 5px 15px;
    }
    .privilege{
      .name{
        font-size: small;
        display: flex;
        align-items: baseline;
        .privi-type{
          font-size: 10px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>